import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr2024',
    ecrans: ['00-2'],
    params: ['id','?sidcleint']
});
